// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CheckLoginElectronicInvoiceQueryVariables = Types.Exact<{
  upsertOwnerCorporateDataDTO: Types.UpsertOwnerCorporateDataDtoInput;
}>;


export type CheckLoginElectronicInvoiceQueryResult = { __typename?: 'Query', checkLoginElectronicInvoice: boolean };

export const CheckLoginElectronicInvoiceGql = gql`
    query CheckLoginElectronicInvoice($upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDTOInput!) {
  checkLoginElectronicInvoice(
    upsertOwnerCorporateDataDTO: $upsertOwnerCorporateDataDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckLoginElectronicInvoiceInjectable extends Apollo.Query<CheckLoginElectronicInvoiceQueryResult, CheckLoginElectronicInvoiceQueryVariables> {
    override document = CheckLoginElectronicInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */